// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"148b95f2","404":"879b67a1","540":"c769d0c8"}[chunkId] + ".chunk.js";
};